module.exports = __webpack_public_path__ + "static/media/how-to-create-a-pdf-file-containing-images.e0c6fd3c.pdf";